// Apolo IDE — ComposerFooterStrip (Pedro 2026-06-25, sprint cursor-strip).
//
// Linha discreta logo abaixo do composer com STATUS persistente do turno:
//   branch atual · cloud/local · model label · tokens · custo
// Substitui o antigo `rx-composer-cost` (que só ficava visível DEPOIS do turno
// fechar). Aqui a linha vive o tempo todo — vazia/idle = quase invisível,
// rodando = mostra running + provider, fechada = mostra custo do último turno.
//
// Minimalismo radical: mono 10.5px, opacity .55 default (.85 no running),
// SEM cor de accent, SEM borda própria. Quem desenha é o `rx-composer`.
// PRESENTACIONAL puro — recebe props (não fetcha). I/O fica nos hooks do
// SessionComposer.

import { GitBranch } from 'lucide-react';
import { providerOf } from '../../../lib/modelRegistry.js';
import { sessionKind } from '../../../lib/code/sessionKind.js';

function ProviderDot({ model }) {
  const prov = providerOf(model);
  const { Icon, label } = sessionKind(model);
  if (!Icon) return null;
  return (
    <span
      className="inline-flex items-center gap-1"
      title={`Execução ${label} (${prov})`}
    >
      <Icon size={10} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}

function BranchPill({ branch }) {
  if (!branch) return null;
  return (
    <span className="inline-flex items-center gap-1" title={`Branch: ${branch}`}>
      <GitBranch size={10} aria-hidden="true" />
      <span className="truncate" style={{ maxWidth: 160 }}>{branch}</span>
    </span>
  );
}

export function ComposerFooterStrip({
  branch,
  model,
  running,
  lastTurnCost,
  contextUsage,
}) {
  const hasAnything = branch || model || running || lastTurnCost;
  if (!hasAnything) return null;

  const tokens = lastTurnCost?.tokens ?? contextUsage?.totalTokens ?? null;
  const cost = lastTurnCost?.usd ?? null;
  const usagePct =
    contextUsage?.windowTokens && contextUsage.totalTokens
      ? Math.round((contextUsage.totalTokens / contextUsage.windowTokens) * 100)
      : null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-running={running ? 'true' : 'false'}
      className="rx-composer-strip"
      data-testid="composer-footer-strip"
    >
      <BranchPill branch={branch} />
      {branch && (model || running || lastTurnCost) ? (
        <span aria-hidden="true" className="rx-composer-strip-sep">·</span>
      ) : null}
      <ProviderDot model={model} />
      {model && (running || lastTurnCost) ? (
        <span aria-hidden="true" className="rx-composer-strip-sep">·</span>
      ) : null}
      {running ? (
        <span className="rx-composer-strip-run">rodando…</span>
      ) : null}
      {!running && tokens != null ? (
        <span className="font-mono" title="Tokens do último turno">
          {Number(tokens).toLocaleString()} tok
        </span>
      ) : null}
      {!running && cost != null ? (
        <span className="font-mono" title="Custo do último turno">
          ${Number(cost).toFixed(4)}
        </span>
      ) : null}
      {!running && usagePct != null && !tokens ? (
        <span className="font-mono" title="Uso da janela de contexto">
          {usagePct}%
        </span>
      ) : null}
      <span className="workbench-compose-shortcut" aria-hidden="true"><kbd>↵</kbd> enviar <span>·</span> <kbd>⇧ ↵</kbd> nova linha</span>
    </div>
  );
}

export default ComposerFooterStrip;
